module.exports = __webpack_public_path__ + "static/media/brackets.3240c53d.png";